import { boot } from "quasar/wrappers";
import firebase from "firebase/app";
import "firebase/analytics";
import { Platform } from "quasar";
import { useCommonStore } from "src/stores/common-store";
import { inIframe } from "src/utils";
import { cordovaFirebaseConfig, webFirebaseConfig } from "src/constants";
import { getAccountID } from "src/utils/commonFunction";

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async ({ app, store }) => {
  if (inIframe()) return;

  const commonStore = useCommonStore(store);

  let response = await commonStore.getStoreConfiguration();

  let firebaseConfig = {};
  if (response?.status && response?.items && getAccountID()) {
    if (
      response?.items?.firebase_config &&
      Object.keys(response?.items?.firebase_config).length
    ) {
      // console.log("-------------firebase_config main---------------");
      firebaseConfig = response?.items?.firebase_config;
      // console.log(response?.items?.firebase_config);
      // console.log("----------------------------");
    }
  } else {
    if (Platform.is.cordova) {
      if (process.env.APP_ENV == "prod") {
        firebaseConfig = cordovaFirebaseConfig.prod;
      } else {
        firebaseConfig = cordovaFirebaseConfig.dev;
      }
    } else {
      if (process.env.APP_ENV == "prod") {
        firebaseConfig = webFirebaseConfig.prod;
      } else {
        firebaseConfig = webFirebaseConfig.dev;
      }
    }
  }

  var firebaseApp;
  if (
    Object.keys(firebaseConfig).length &&
    firebaseConfig?.projectId &&
    firebaseConfig?.projectId.length
  ) {
    // console.log("Config Setup for from boot-----------");
    // console.log(firebaseConfig);
    // console.log("-----------");
    if (firebase.apps.length === 0) {
      firebaseApp = firebase.initializeApp(firebaseConfig);
      // Initialize Analytics and get a reference to the service
      const analytics = firebase.analytics();
      app.config.globalProperties.firebaseSDK = firebaseApp;
    } else firebaseApp = firebase.apps[0];
  }
});
